import React from 'react';
import ApplicationPremiumSettingsHOC from '../../containers/ApplicationPremiumSettings/applicationPremiumSettingsHOC';
import ModalWrapper from '../../helpers/modalWrapper';
import { SIZE_LG } from '../../helpers/constants';

const ApplicationPremiumSettingsModal = (props) => {

    const {
        isOpen,
        handleClose,
        onEditStaged,
        isEditStaged,
        isChangingStatusOfApp,
        showTable,
        isEditMode,
        isApplicationPremium,
        applicationPremiumSaveButtonLabel,
        applicationPremiumCancelHandler,
        selectedApplicationCaseTypeId,
        onCancel,        
    } = props;

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={handleClose}
            size={SIZE_LG}
            modalTestId={'application-premium-setting-modal'}
            buttonTestId={'application-premium-setting-modal-close'}
        >
			<ApplicationPremiumSettingsHOC
				onEditStaged={onEditStaged}
				isEditStaged={isEditStaged}
				isChangingStatusOfApp={isChangingStatusOfApp}
				showTable={showTable}
				isEditMode={isEditMode}
				isApplicationPremium={isApplicationPremium}
				applicationPremiumSaveButtonLabel={applicationPremiumSaveButtonLabel}
				applicationPremiumCancelHandler={applicationPremiumCancelHandler}
				selectedApplicationCaseTypeId={selectedApplicationCaseTypeId}
				onCancel={onCancel}
			/>
        </ModalWrapper>
    );
};

export default ApplicationPremiumSettingsModal;